import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from './../../../../../../Containers/Config/index';
import { CREATE_CAMPAIGN_EFFECT, CREATE_CAMPAIGN_EFFECT_SUCCESS, CREATE_CAMPAIGN_EFFECT_ERROR } from './../../../../actionType';
import apiCall from '../../../../apiCall';
import { Constant } from '../../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

// Persists the campaign's effects: deletes removed effects, updates the ones already
// created (PUT), and creates the new ones (POST) — so revisiting the step never
// duplicates an effect. Returns the local-id → server-id map so Controls & Guardrails
// can update each effect's caps by id.
function* createCampaignEffect({ payload }) {
  try {
    const { campaignId, creates = [], updates = [], deletes = [] } = payload?.data || {};
    const headers = { ...customHeaders };
    delete headers['X-Requested-By'];
    const resultEffects = [];

    // 1. Remove effects the user deleted after they were persisted.
    for (let i = 0; i < deletes.length; i++) {
      yield call(apiCall, {
        url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/effects/${deletes[i]}`,
        method: 'DELETE',
        headers,
      });
    }

    // 2. Update the effects that already exist.
    for (let i = 0; i < updates.length; i++) {
      const effect = updates[i];
      const response = yield call(apiCall, {
        url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/effects/${effect.effectId}`,
        method: 'PUT',
        headers,
        data: effect.body,
      });

      if (response.status === 200 || response.status === 201) {
        resultEffects.push({ localId: effect.localId, id: effect.effectId, data: response?.data?.results || response?.data?.result || response?.data || {} });
      } else {
        cogoToast.error(response?.response?.data?.message || `Failed to update effect "${effect?.body?.name || ''}".`);
        yield put({ type: CREATE_CAMPAIGN_EFFECT_ERROR, payload: response?.response?.data?.message });
        return;
      }
    }

    // 3. Create the brand-new effects.
    for (let i = 0; i < creates.length; i++) {
      const effect = creates[i];
      const response = yield call(apiCall, {
        url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/effects`,
        method: 'POST',
        headers,
        data: effect.body,
      });

      if (response.status === 200 || response.status === 201) {
        const data = response?.data?.results || response?.data?.result || response?.data || {};
        resultEffects.push({ localId: effect.localId, id: data?.id || data?.objectId || data?.effect_id, data });
      } else {
        cogoToast.error(response?.response?.data?.message || `Failed to create effect "${effect?.body?.name || ''}".`);
        yield put({ type: CREATE_CAMPAIGN_EFFECT_ERROR, payload: response?.response?.data?.message });
        return;
      }
    }

    cogoToast.success(`Effects saved successfully.`);
    yield put({
      type: CREATE_CAMPAIGN_EFFECT_SUCCESS,
      payload: resultEffects,
    });
  } catch (error) {
    yield put({ type: CREATE_CAMPAIGN_EFFECT_ERROR, payload: error });
  }
}

export function* watchCreateCampaignEffectSaga() {
  yield takeEvery(CREATE_CAMPAIGN_EFFECT, createCampaignEffect);
}

function* createCampaignEffectSaga() {
  yield all([fork(watchCreateCampaignEffectSaga)]);
}

export default createCampaignEffectSaga;
